export const RATE__0_25 = 0.25;
export const RATE__0_5 = 0.5;
export const RATE__0_75 = 0.75;
export const RATE__1 = 1;
export const RATE__1_25 = 1.25;
export const RATE__1_5 = 1.5;
export const RATE__1_75 = 1.75;
export const RATE__2 = 2;
export const RATE__4 = 4;
export const RATE__8 = 8;
export const RATE__16 = 16;
